// extracted by mini-css-extract-plugin
module.exports = {"button-container":"Button_button-container__3EKj5","button":"Button_button__1QqF-","icon-left":"Button_icon-left__2Q9SG","icon-right":"Button_icon-right__1UGK4"};